import "./StatusCell.css";
import React, { FunctionComponent } from "react";

export type CellType = "ok" | "failed" | "aborted";

export interface StatusCellProps {
    cellTypes: CellType[];
    cellSize?: number;      // default: 10
    cellSpacing?: number;   // default: 4
}

export const StatusCell: FunctionComponent<StatusCellProps> = ({
                                                                   cellTypes,
                                                                   cellSize = 10,
                                                                   cellSpacing = 4,
                                                               }) => {
    const MAX_COLUMNS = 4;

    const STEP = cellSize + cellSpacing;
    const half = cellSize / 2;

    const rowCount = Math.ceil(cellTypes.length / MAX_COLUMNS);

    const TOTAL_WIDTH =
        cellSize * MAX_COLUMNS + cellSpacing * (MAX_COLUMNS - 1);

    const TOTAL_HEIGHT =
        rowCount > 0
            ? cellSize * rowCount + cellSpacing * (rowCount - 1)
            : 0;

    return (
        <div className="statuscell-container">
            {rowCount > 0 && (
                <svg
                    className="statuscell-svg"
                    width={TOTAL_WIDTH}
                    height={TOTAL_HEIGHT}
                >
                    {cellTypes.map((cellType, index) => {
                        const row = Math.floor(index / MAX_COLUMNS);
                        const col = index % MAX_COLUMNS;

                        const x = col * STEP;
                        const y = row * STEP;

                        const cx = x + half;
                        const cy = y + half;

                        return (
                            <g
                                key={index}
                                className={`statuscell-cell statuscell-${cellType}`}
                            >
                                {/* OK → green circle */}
                                {cellType === "ok" && (
                                    <circle
                                        cx={cx}
                                        cy={cy}
                                        r={half}
                                    />
                                )}

                                {/* Failed → red square */}
                                {cellType === "failed" && (
                                    <rect
                                        x={x}
                                        y={y}
                                        width={cellSize}
                                        height={cellSize}
                                    />
                                )}

                                {/* Aborted → yellow triangle */}
                                {cellType === "aborted" && (
                                    <polygon
                                        points={`
                                            ${cx},${y}
                                            ${x + cellSize},${y + cellSize}
                                            ${x},${y + cellSize}
                                        `}
                                    />
                                )}
                            </g>
                        );
                    })}
                </svg>
            )}
        </div>
    );
};
